{
  "$schema": "https://mux.run/theme.json",
  "name": "Material",
  "id": "material",
  "light": {
    "palette": {
      "neutral": "#fafafa",
      "ink": "#263238",
      "primary": "#6182b8",
      "accent": "#39adb5",
      "success": "#91b859",
      "warning": "#ffb300",
      "error": "#e53935",
      "info": "#f4511e",
      "interactive": "#39adb5"
    },
    "overrides": {
      "text-weak": "#90a4ae",
      "syntax-comment": "#90a4ae",
      "syntax-keyword": "#7c4dff",
      "syntax-string": "#91b859",
      "syntax-primitive": "#6182b8",
      "syntax-variable": "#263238",
      "syntax-property": "#7c4dff",
      "syntax-type": "#ffb300",
      "syntax-constant": "#f4511e",
      "syntax-operator": "#39adb5",
      "syntax-punctuation": "#263238",
      "syntax-object": "#263238",
      "markdown-heading": "#6182b8",
      "markdown-text": "#263238",
      "markdown-link": "#39adb5",
      "markdown-link-text": "#7c4dff",
      "markdown-code": "#91b859",
      "markdown-block-quote": "#90a4ae",
      "markdown-emph": "#ffb300",
      "markdown-strong": "#f4511e",
      "markdown-horizontal-rule": "#e0e0e0",
      "markdown-list-item": "#6182b8",
      "markdown-list-enumeration": "#39adb5",
      "markdown-image": "#39adb5",
      "markdown-image-text": "#7c4dff",
      "markdown-code-block": "#263238"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#263238",
      "ink": "#eeffff",
      "primary": "#82aaff",
      "accent": "#89ddff",
      "success": "#c3e88d",
      "warning": "#ffcb6b",
      "error": "#f07178",
      "info": "#ffcb6b",
      "interactive": "#89ddff"
    },
    "overrides": {
      "text-weak": "#546e7a",
      "syntax-comment": "#546e7a",
      "syntax-keyword": "#c792ea",
      "syntax-string": "#c3e88d",
      "syntax-primitive": "#82aaff",
      "syntax-variable": "#eeffff",
      "syntax-property": "#c792ea",
      "syntax-type": "#ffcb6b",
      "syntax-constant": "#ffcb6b",
      "syntax-operator": "#89ddff",
      "syntax-punctuation": "#eeffff",
      "syntax-object": "#eeffff",
      "markdown-heading": "#82aaff",
      "markdown-text": "#eeffff",
      "markdown-link": "#89ddff",
      "markdown-link-text": "#c792ea",
      "markdown-code": "#c3e88d",
      "markdown-block-quote": "#546e7a",
      "markdown-emph": "#ffcb6b",
      "markdown-strong": "#ffcb6b",
      "markdown-horizontal-rule": "#37474f",
      "markdown-list-item": "#82aaff",
      "markdown-list-enumeration": "#89ddff",
      "markdown-image": "#89ddff",
      "markdown-image-text": "#c792ea",
      "markdown-code-block": "#eeffff"
    }
  }
}
